import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const ZarazeniPnv = {
	name: NAME,
	apiProvider,
	router,
};
